import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { Box, Text } from '@wix/design-system';

const NoReviews: FC<{
  hasNegativeMargin: boolean;
  noReviewsKey: string;
  isMobileView?: boolean;
}> = ({ hasNegativeMargin, noReviewsKey, isMobileView }) => {
  const { t } = useTranslation();
  return (
    <Box
      marginTop={hasNegativeMargin ? '-18px' : '18px'}
      paddingBottom={isMobileView ? '30px' : '0'}
    >
      <Text size="small" weight="thin" dataHook="no-reviews-text">
        {t(noReviewsKey)}
      </Text>
    </Box>
  );
};

export default NoReviews;
